<template>
  <div class="container">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item class="black">{{
        t("vehiclemanagement")
      }}</a-breadcrumb-item>
      <a-breadcrumb-item class="currentrouter">{{
        t("vehiclelist")
      }}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="search-input-group">
      <a-input
        style="width: 16%"
        v-model:value="keyWord"
        :placeholder="t('supportvinvehiclenamecustomer')"
      />
      <a-button class="searchBtn" style="margin-right: 20px" @click="search">{{
        t("search")
      }}</a-button>
      <a-select
        v-model:value="optionValue"
        style="width: 10%"
        @change="getListData"
      >
        <a-select-option
          v-for="item in onLineStatusOptions"
          :key="item.value"
          v-model:value="item.value"
        >
          {{ item.label }}</a-select-option
        >
      </a-select>
    </div>
    <a-table
      :dataSource="dataSource"
      :columns="columns"
      :pagination="false"
      :scroll="{ y: maxHeight, x: 1400 }"
    >
      <template v-slot:bodyCell="{ text, record, column, index }">
        <template v-if="column.title === t('serialnumber')">
          {{ index + 1 }}</template
        >
        <template v-if="column.title === t('onlineornot')">
          {{ text === "1" ? t("online") : t("offline") }}</template
        >
        <template v-if="column.title === t('vehiclestatus')">
          {{ getCarStatusType(text, t) }}</template
        >
        <template v-if="column.title === t('faultstatus')">
          {{ text ? t("yes") : t("deny") }}</template
        >
        <template v-else-if="column.dataIndex === 'car_model'">
          <div class="operate" v-if="record.vehicle_model !== 'Mix1'">
            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link" @click="checkItem(record)">
                <img
                  v-if="record.vin !== checkedId"
                  src="../assets/images/notclicked.png"
                  alt=""
                />
                <img v-else src="../assets/images/clicked.png" alt="" />
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item
                    key="0"
                    v-if="root?.role_type === 1"
                    @click="goToVehicleInfo(record.vin, record.category_id)"
                  >
                    {{ t("vehicleinformation") }}</a-menu-item
                  ><a-menu-divider />
                  <a-menu-item
                    key="1"
                    @click="goScheduledTasksInfo(record.vin)"
                    >{{ t("scheduledtasks") }}</a-menu-item
                  ><a-menu-divider />
                  <a-menu-item key="2" @click="goVisualization(record.vin)">{{
                    t("resourcestatistics")
                  }}</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </template>
      </template>
    </a-table>
    <a-pagination
      class="pagination"
      show-size-changer
      show-quick-jumper
      :show-total="(total) => `${t('intotal')} ${total}${t('article')}`"
      v-model:current="pagination.page"
      v-model:pageSize="pagination.size"
      :total="pagination.total"
      size="small"
      @change="getListData"
    />
  </div>
</template>
<script>
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import { defineComponent, ref, onMounted, computed } from "vue";
import { message } from "ant-design-vue";
import { useRouter } from "vue-router";
import { getCarStatusType } from "@/constant/DataType";
import routerName from "@/router/routerName";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "VehicleList",
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const maxHeight = computed(() => store.getters.getMaxHeight);
    const dataSource = ref();
    const router = useRouter();
    const pagination = ref({
      page: 1,
      size: 10,
      total: 0,
    });
    const root = JSON.parse(sessionStorage.getItem("user_role"));
    const keyWord = ref("");
    const optionValue = ref("0");
    const onLineStatusOptions = ref([
      {
        value: "0",
        label: t("whole"),
      },
      {
        value: "1",
        label: t("online"),
      },
      {
        value: "2",
        label: t("notonline"),
      },
    ]);
    const getListData = () => {
      const params = {
        page: pagination.value.page,
        size: pagination.value.size,
        is_login: optionValue.value,
        keyword: keyWord.value,
      };
      Api.getCarList(params).then((res) => {
        if (res.err_no == ResultCodeType.success_200) {
          dataSource.value = res.result;
          pagination.value.total = res.totalNum * 1;
        } else {
          message.error(res.err_msg);
        }
      });
    };
    const search = () => {
      pagination.value.page = 1;
      getListData();
    };
    const goVisualization = (vin) => {
      router.push({
        path: routerName.visualization,
        query: {
          vin,
        },
      });
    };
    const goScheduledTasksInfo = (vin) => {
      router.push({
        path: routerName.scheduledtasks,
        query: {
          vin,
        },
      });
    };
    const goToVehicleInfo = (vin, id) => {
      router.push({
        path: routerName.basicInfo,
        query: { vin: vin, category_id: id },
      });
    };
    const checkedId = ref("");
    const checkItem = (value) => {
      checkedId.value = value.vin;
    };
    onMounted(() => {
      getListData();
    });
    return {
      checkItem,
      checkedId,
      dataSource,
      columns: [
        {
          title: t("serialnumber"),
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 150,
        },
        {
          title: "VIN",
          dataIndex: "vin",
          key: "vin",
          align: "center",
        },
        {
          title: t("vehiclename"),
          dataIndex: "vehicle_name",
          key: "vehicle_name",
          align: "center",
        },
        {
          title: t("customername"),
          dataIndex: "organization_name",
          key: "organization_name",
          align: "center",
        },
        {
          title: t("onlineornot"),
          dataIndex: "is_login",
          key: "is_login",
          align: "center",
        },
        {
          title: t("vehiclemodel"),
          dataIndex: "vehicle_model",
          key: "vehicle_model",
          align: "center",
        },
        {
          title: t("vehiclestatus"),
          dataIndex: "vehicle_status",
          key: "vehicle_status",
          align: "center",
        },
        {
          title: t("faultstatus"),
          dataIndex: "is_fault",
          key: "is_fault",
          align: "center",
        },
        {
          title: t("registrationtime"),
          dataIndex: "register_time",
          key: "register_time",
          align: "center",
        },
        {
          title: t("operate"),
          dataIndex: "car_model",
          key: "car_model",
          width: 100,
          align: "center",
        },
      ],
      getCarStatusType,
      keyWord,
      getListData,
      pagination,
      onLineStatusOptions,
      optionValue,
      goVisualization,
      goScheduledTasksInfo,
      goToVehicleInfo,
      root,
      search,
      maxHeight,
      t,
    };
  },
});
</script>
<style scoped>
.addBtn {
  position: absolute;
  margin-top: 13px;
  right: 180px;
}
.delBtn {
  position: absolute;
  margin-top: 13px;
  right: 80px;
}
.disabled {
  color: #ccc !important;
  pointer-events: none;
}
.ant-pagination >>> .ant-pagination-options-quick-jumper {
  color: red;
}
</style>
